<template>
  <div>
    <a-modal
      width="650px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="项目配置"
      @ok="handleSubmit"
    >
      <a-spin :spinning="loading">
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-form-item label="模组厂商">
            <a-input :value="data.module_producer_name" disabled />
          </a-form-item>

          <a-form-item label="模组型号">
            <a-input :value="data.module_model_name" disabled />
          </a-form-item>

          <a-form-item label="供应商">
            <a-select
              v-decorator="['module_supplier_id', {
                rules: [{ required: true, message: '请选择供应商' }]
              }]"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择供应商"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="option in supplierOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { findModuleSuppliers } from '@/api/module_supplier'
import {
  findAgentPurchaseItemModuleConfigureForm,
  approveModulePurchaseItem
} from '@/api/agent_purchase_item'

export default {
  name: 'ConfigureModulePurchaseItem',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true,
      submitting: false,
      loadingSupplierOptions: false,
      supplierOptions: [],
      form: this.$form.createForm(this, { name: 'configure_module_purchase_item' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchSupplierOptions()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findModuleSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    fetchData() {
      this.loading = true
      findAgentPurchaseItemModuleConfigureForm(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.$nextTick(() => {
            this.form.setFieldsValue({
              module_supplier_id: res.data.module_supplier_id === 0
                ? undefined
                : res.data.module_supplier_id
            })
          })
        }
        this.loading = false
      })
    },

    handleSubmit(e) {
      if (e && e.preventDefault) e.preventDefault()
      if (this.submitting) return
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        approveModulePurchaseItem(this.id, values).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
